module.exports = __webpack_public_path__ + "static/media/Arrow.e2e7662c.svg";